var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 638,
    viewBox: "0 0 530 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_105_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.093 340.606C328.253 361.981 327.298 370.505 326.335 374.4C326.615 378.582 326.834 383.216 326.964 388.373C324.706 403.489 321.954 414.133 315.329 419.185C308.481 424.408 300.416 430.112 291.119 431.715C280.598 433.529 248.469 442.789 228.645 432.265C212.524 423.708 189.707 403.88 186.242 389.904C182.634 375.348 177.031 364.369 177.563 342.371C178.817 290.533 182.613 278.464 184.512 264.913C186.466 250.965 189.2 229.184 206.193 219.55C228.8 206.733 240.796 193.969 288.583 203.085C303.632 205.956 314.795 211.164 322.719 221.278C326.394 225.967 328.203 230.878 328.987 254.16C329.772 277.442 329.987 317.883 329.093 340.606Z",
    fill: "#3B8B8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_105_139",
    x: -22.4721,
    y: 0,
    width: 552.147,
    height: 637.212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_105_139"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector-4.ea5033828950d6927b6561f3b78b5b7f.svg";
export { ForwardRef as ReactComponent };